import { cn } from '@/app/utils'

type Props = {
  width?: number
  height?: number
  className?: string
}

export const CardSkeleton = ({ width, height, className }: Props) => (
  <div
    data-testid="skeleton-card-id"
    style={{
      maxWidth: `${width}px`,
      maxHeight: `${height}px`,
      height: `${height}px`
    }}
    className={cn('animate-pulse rounded-12 bg-[rgba(16,24,32,.1)]', className)}
  />
)
